import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const Verktyg = lazy(() => import("@/pages/mina-sidor/Verktyg"));

export const Route = createFileRoute("/mina-sidor/verktyg")({
  component: () => <Verktyg />,
});
